

















































import { Component, Ref, Vue, Watch, Prop } from "vue-property-decorator";
import DiagItemRow from "@/components/DiagItemRow.vue";
import { DiagItem } from "@/types/diag_procedure";
import { userModule } from "@/store/modules/user";
import { storePasien } from "@/store/modules/pasien";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";

@Component({
  components: {
    DiagItemRow
  }
})
export default class DiagnosisICDPanel extends Vue {
  @Ref() rowDiag;

  @Prop({ default: [] }) diags: DiagItem[] = [];

  addDiag() {
    this.diags.push({
      id: null,
      icd: null,
      diag: null,
      kasus: null,
      pasien_rm: storePasien.identitasPasien.rm,
      register_id: RegisterKunjungan.register["no"],
      unit_id: userModule.user.unit_id
    });

    const rows = this.diags.length,
      lastIdx = rows - 1;

    this.$nextTick(() => {
      this.rowDiag[lastIdx].focus();
    });
  }

  removeDiag(idx) {
    this.diags.splice(idx, 1);

    const rows = this.diags.length,
      lastIdx = rows - 1;
    this.$nextTick(() => {
      this.rowDiag[lastIdx].focus();
    });
  }

  get diagsList() {
    return this.diags
      .map((item, index) => {
        item.level = index == 0 ? "p" : "s";

        return item;
      })
      .sort((itemA, itemB) => {
        if (itemB.level < itemA.level) {
          return 1;
        }

        if (itemB.level > itemA.level) {
          return -1;
        }

        return 0;
      });
  }

  @Watch("diags", { deep: true })
  changeDiags(val) {
    this.$emit("changeData", val);
  }

  changeItemRow(val, idx) {
    console.log("change item diag row", val);
    // this.setLevel(val.level, idx);
  }

  setLevel(level, idx) {
    const row = this.diags[idx];

    console.log("idx: " + idx + " level: " + level);

    if (level == "p") {
      this.diags.splice(idx, 1);
      this.diags.unshift(row);
    } else {
      this.diags.splice(idx, 1);
      this.diags.push(row);
    }
  }
}
